(() => {
  if (window.__dueDatePopupBound) return;
  window.__dueDatePopupBound = true;

  const CHECKOUT_SELECTOR = '#CartDrawer-Checkout, #checkout, [data-due-date-checkout], [data-eisen-checkout]';
  let checkoutIntercepted = false;

  const getPopup = () => document.querySelector('eisen-boost-checkout-popup');

  const getConfiguredProduct = () => {
    const popup = getPopup();
    const button = document.querySelector('[data-due-date-product-handle], [data-due-date-checkout]');
    const globalConfig = window.dueDatePopupConfig || {};
    return {
      id: String(
        popup?.dataset.productId ||
          button?.dataset.dueDateProductId ||
          globalConfig.productId ||
          ''
      ).trim(),
      handle: String(
        popup?.dataset.productHandle ||
          button?.dataset.dueDateProductHandle ||
          globalConfig.productHandle ||
          ''
      )
        .trim()
        .toLowerCase(),
    };
  };

  const getItemProperty = (item, name) => {
    const props = item?.properties;
    if (!props) return '';
    if (typeof props === 'object' && !Array.isArray(props)) {
      return String(props[name] ?? '').trim();
    }
    if (Array.isArray(props)) {
      const entry = props.find((prop) => prop.name === name || prop.first === name);
      return String(entry?.value ?? entry?.last ?? '').trim();
    }
    return '';
  };

  const isFreeGiftLine = (item) =>
    Boolean(getItemProperty(item, 'Gratis dazu') || getItemProperty(item, 'gratis_dazu'));

  const isSubscriptionLine = (item) => {
    if (isFreeGiftLine(item)) return false;
    if (item?.selling_plan_allocation) return true;
    if (item?.selling_plan) return true;
    if (getItemProperty(item, '_sparplan_primary')) return true;
    return false;
  };

  const matchesConfiguredProduct = (item, config) => {
    const itemHandle = String(item.handle || '').toLowerCase();
    if (config.handle && itemHandle === config.handle) return true;
    if (config.id && String(item.product_id) === config.id) return true;
    return false;
  };

  const cartDomHasConfiguredSubscription = (config) => {
    if (!config.id && !config.handle) return false;
    return Array.from(document.querySelectorAll('.cart-item[data-product-handle]')).some((row) => {
      const rowHandle = String(row.dataset.productHandle || '').toLowerCase();
      const rowId = String(row.dataset.productId || '');
      const matches =
        (config.handle && rowHandle === config.handle) || (config.id && rowId === config.id);
      return matches && row.dataset.sellingPlan === 'true';
    });
  };

  const cartHasConfiguredSubscription = (cart) => {
    const config = getConfiguredProduct();
    if (!config.id && !config.handle) return false;

    const fromApi = (cart?.items || []).some(
      (item) => matchesConfiguredProduct(item, config) && isSubscriptionLine(item)
    );
    if (fromApi) return true;
    return cartDomHasConfiguredSubscription(config);
  };

  const openPopup = () => {
    const popup = getPopup();
    if (!popup) return false;
    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }
    if (typeof popup.open === 'function') {
      popup.open();
      return true;
    }
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    return true;
  };

  const checkoutUrl = () => `${window.Shopify?.routes?.root || '/'}checkout`;

  const goToCheckout = () => {
    window.location.href = checkoutUrl();
  };

  const shouldCheckDueDate = () => {
    const config = getConfiguredProduct();
    return Boolean((config.id && config.id !== 'null') || config.handle || getPopup());
  };

  const interceptCheckout = async (event, button) => {
    if (!button || button.disabled) return;
    if (!shouldCheckDueDate()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (checkoutIntercepted) return;
    checkoutIntercepted = true;

    const config = getConfiguredProduct();
    const flagged = button.getAttribute('data-due-date-popup') || button.getAttribute('data-eisen-boost');

    try {
      if (flagged === 'true' || cartDomHasConfiguredSubscription(config)) {
        checkoutIntercepted = false;
        if (!openPopup()) goToCheckout();
        return;
      }

      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await response.json();
      if (cartHasConfiguredSubscription(cart)) {
        checkoutIntercepted = false;
        if (!openPopup()) goToCheckout();
        return;
      }
    } catch (error) {
      checkoutIntercepted = false;
      if (flagged === 'true' && openPopup()) return;
    }

    goToCheckout();
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(CHECKOUT_SELECTOR);
      if (!button) return;
      interceptCheckout(event, button);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form || (form.id !== 'CartDrawer-Form' && form.id !== 'cart')) return;
      const button =
        event.submitter ||
        form.querySelector('[name="checkout"]') ||
        document.querySelector(CHECKOUT_SELECTOR);
      if (!button) return;
      interceptCheckout(event, button);
    },
    true
  );

  if (!customElements.get('eisen-boost-checkout-popup')) {
    customElements.define(
      'eisen-boost-checkout-popup',
      class EisenBoostCheckoutPopup extends HTMLElement {
        constructor() {
          super();
          this.attributeName = 'Entbindungstermin';
          this.isOpen = false;
          this.proceeding = false;
          this.onKeydown = this.onKeydown.bind(this);
        }

        connectedCallback() {
          this.attributeName = this.dataset.attributeName || this.attributeName;
          this.overlay = this.querySelector('[data-eisen-overlay]');
          this.dialog = this.querySelector('[data-eisen-dialog]');
          this.form = this.querySelector('[data-eisen-form]');
          this.dateInput = this.querySelector('[data-eisen-date]');
          this.dateDisplay = this.querySelector('[data-eisen-date-display]');
          this.calendarButton = this.querySelector('[data-eisen-calendar]');
          this.closeButton = this.querySelector('[data-eisen-close]');
          this.saveButton = this.querySelector('[data-eisen-save]');
          this.skipButton = this.querySelector('[data-eisen-skip]');
          this.error = this.querySelector('[data-eisen-error]');

          if (this.parentElement !== document.body) {
            document.body.appendChild(this);
            return;
          }

          this.setSavedDate(this.dataset.savedDate || '');
          this.applyNativePickerMode();
          this.bindEvents();
        }

        applyNativePickerMode() {
          this.classList.add('is-native-date-picker');
          if (this.dateDisplay) {
            this.dateDisplay.readOnly = true;
            this.dateDisplay.setAttribute('inputmode', 'none');
            this.dateDisplay.setAttribute('tabindex', '-1');
            this.dateDisplay.setAttribute('aria-hidden', 'true');
          }
          if (this.dateInput) {
            this.dateInput.removeAttribute('aria-hidden');
            this.dateInput.removeAttribute('tabindex');
            const label = this.querySelector('label[for="EisenBoostDueDateDisplay"]');
            if (label) label.setAttribute('for', this.dateInput.id);
          }
        }

        bindEvents() {
          if (this.eventsBound) return;
          this.eventsBound = true;

          this.overlay?.addEventListener('click', () => this.close());
          this.closeButton?.addEventListener('click', () => this.close());
          this.skipButton?.addEventListener('click', () => this.proceedToCheckout());
          this.calendarButton?.addEventListener('click', () => this.openNativePicker());
          this.form?.addEventListener('submit', (event) => {
            event.preventDefault();
            this.saveAndCheckout();
          });
          this.dateDisplay?.addEventListener('pointerdown', (event) => {
            event.preventDefault();
            this.openNativePicker();
          });
          this.dateInput?.addEventListener('change', () => {
            this.hideError();
            if (this.dateDisplay) this.dateDisplay.value = this.toDisplayDate(this.dateInput.value);
          });
        }

        onKeydown(event) {
          if (event.key === 'Escape' && this.isOpen) {
            event.preventDefault();
            this.close();
          }
        }

        open() {
          if (this.parentElement !== document.body) {
            document.body.appendChild(this);
          }

          this.isOpen = true;
          this.classList.add('is-open');
          this.setAttribute('aria-hidden', 'false');
          this.hideError();
          document.addEventListener('keydown', this.onKeydown, true);

          const focusTarget = this.closeButton || this.dialog;
          if (typeof trapFocus === 'function') {
            trapFocus(this, focusTarget);
          } else {
            focusTarget?.focus();
          }
        }

        close() {
          if (!this.isOpen) return;
          this.isOpen = false;
          this.classList.remove('is-open');
          this.setAttribute('aria-hidden', 'true');
          document.removeEventListener('keydown', this.onKeydown, true);

          const checkoutButton = document.querySelector(CHECKOUT_SELECTOR);
          if (typeof removeTrapFocus === 'function') {
            removeTrapFocus(checkoutButton);
          }
        }

        setSavedDate(value) {
          const displayValue = this.normalizeDisplayDate(value);
          if (this.dateDisplay) this.dateDisplay.value = displayValue;
          if (this.dateInput) this.dateInput.value = this.toIsoDate(displayValue);
        }

        normalizeDisplayDate(value) {
          if (!value) return '';
          if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return this.toDisplayDate(value);
          const match = String(value).match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
          if (!match) return String(value);
          return `${match[1].padStart(2, '0')}.${match[2].padStart(2, '0')}.${match[3]}`;
        }

        toDisplayDate(isoDate) {
          if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return '';
          const [year, month, day] = isoDate.split('-');
          return `${day}.${month}.${year}`;
        }

        toIsoDate(displayDate) {
          const match = String(displayDate || '').match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
          if (!match) return '';
          return `${match[3]}-${match[2].padStart(2, '0')}-${match[1].padStart(2, '0')}`;
        }

        isValidDate(displayDate) {
          const isoDate = this.toIsoDate(displayDate);
          if (!isoDate) return false;
          const parsed = new Date(`${isoDate}T00:00:00`);
          if (Number.isNaN(parsed.getTime())) return false;
          const [year, month, day] = isoDate.split('-').map(Number);
          return parsed.getFullYear() === year && parsed.getMonth() + 1 === month && parsed.getDate() === day;
        }

        openNativePicker() {
          if (!this.dateInput) return;
          try {
            if (typeof this.dateInput.showPicker === 'function') {
              this.dateInput.showPicker();
              return;
            }
          } catch (error) {
            // Some browsers only allow showPicker() from a direct user gesture.
          }
          this.dateInput.focus();
          this.dateInput.click();
        }

        hideError() {
          if (this.error) this.error.hidden = true;
        }

        showError() {
          if (!this.error) return;
          this.error.hidden = false;
          this.openNativePicker();
        }

        setBusy(isBusy) {
          [this.saveButton, this.skipButton].forEach((button) => {
            if (button) button.disabled = isBusy;
          });
        }

        buildDueDateNoteLine(date) {
          return `${this.attributeName}: ${date}`;
        }

        mergeDueDateNote(existingNote, date) {
          const noteLine = this.buildDueDateNoteLine(date);
          const labelPattern = new RegExp(`^\\s*${this.attributeName}\\s*:\\s*.+$`, 'im');
          const currentNote = String(existingNote || '').trim();

          if (!currentNote) return noteLine;
          if (labelPattern.test(currentNote)) {
            return currentNote.replace(labelPattern, noteLine);
          }
          return `${currentNote}\n${noteLine}`;
        }

        syncNoteFields(note) {
          document.querySelectorAll('#CartDrawer-Note, #Cart-note, [name="note"]').forEach((field) => {
            field.value = note;
          });
        }

        async saveAndCheckout() {
          const displayDate = this.dateDisplay?.value?.trim() || '';
          if (!this.isValidDate(displayDate)) {
            this.showError();
            return;
          }

          const formattedDate = this.normalizeDisplayDate(displayDate);
          this.setBusy(true);
          try {
            const cartResponse = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
              headers: { Accept: 'application/json' },
            });
            const cart = cartResponse.ok ? await cartResponse.json() : {};
            const nextNote = this.mergeDueDateNote(cart.note, formattedDate);

            await fetch(window.routes?.cart_update_url || '/cart/update.js', {
              ...fetchConfig(),
              body: JSON.stringify({
                note: nextNote,
                attributes: {
                  [this.attributeName]: formattedDate,
                },
              }),
            });
            this.syncNoteFields(nextNote);
          } catch (error) {
            // Continue to checkout even if the note update fails.
          }
          this.proceedToCheckout();
        }

        proceedToCheckout() {
          if (this.proceeding) return;
          this.proceeding = true;
          this.setBusy(true);
          goToCheckout();
        }
      }
    );
  }
})();
